import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12 2.25C9.11155 2.25 6.767 4.64206 6.767 7.517C6.767 10.3993 9.1189 12.75 12 12.75C14.8884 12.75 17.233 10.3579 17.233 7.483C17.233 4.60068 14.8811 2.25 12 2.25ZM8 14.25C5.38579 14.25 3.25 16.3858 3.25 19V20C3.25 20.9642 4.03579 21.75 5 21.75H19C19.9642 21.75 20.75 20.9642 20.75 20V19C20.75 16.3858 18.6142 14.25 16 14.25H8Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const ProfileFilled = React.forwardRef(IconComponent);
ProfileFilled.displayName = 'ProfileFilled';

export { ProfileFilled };
